import axios from "axios";
import { BASE_URL, BASE_URL_A } from "../Global";
import useAuthStore from "../Store/AuthStore";

// Gifts Like API
export const likeProductAPI = async (giftId) => {
    const { token } = useAuthStore.getState();
    try {
        const response = await axios.put(`${BASE_URL}/api/gifts/like`,
            { giftId },
            {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${token}`,
                },
            });
        return response.data;
    } catch (error) {
        return error;
    }
};

// Clicked Products API
export const logClickedProductAPI = async (params) => {
    try {
        const response = await axios.put(
            `${BASE_URL}/api/gifts/click`,
            JSON.stringify(params),
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// Clicked Products API
export const tagClickAPI = async (giftId, tag, text, language) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/api/gifts/prompt`,
            { giftId, text, tag, language },
            {
                headers: {
                    "Content-type": "application/json; charset=UTF-8",
                },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};

// Search APIs
export const semanticSearchAPI = async (query) => {
    const response = await fetch(`${BASE_URL}/api/gifts/semantic-search`, {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify({ query }),
    });
    return response.json();
};

export const fetchGiftsAPI = async (payload) => {
    const response = await fetch(`${BASE_URL_A}`, {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify(payload),
    });
    return response.json();
};

export const postWPWAPI = async (text, userInfo) => {
    const response = await fetch(`${BASE_URL}/api/wpw/add`, {
        method: "POST",
        headers: { "Content-type": "application/json" },
        body: JSON.stringify({ text, userInfo }),
    });
    return response;
};

export const handleSearchAPI = async (giftIds) => {
    const response = await fetch(`${BASE_URL}/api/gifts/searches`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ giftids: giftIds }),
    });
    if (!response.ok) throw new Error("Network response was not ok");
    return response;
};

// fetch Gfit Details API
export const fetchGiftDetailsAPI = async (giftIDs) => {
    try {
        const response = await axios.post(
            `${BASE_URL}/api/gifts/filter`,
            { attribute: "_id", value: giftIDs },
            {
                headers: {
                    "Content-Type": "application/json",
                },
            }
        );
        return response.data;
    } catch (error) {
        return error;
    }
};
